import { render, staticRenderFns } from "./SliderPrice.vue?vue&type=template&id=6df72884&scoped=true&"
import script from "./SliderPrice.vue?vue&type=script&lang=js&"
export * from "./SliderPrice.vue?vue&type=script&lang=js&"
import style0 from "./SliderPrice.vue?vue&type=style&index=0&id=6df72884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df72884",
  null
  
)

export default component.exports